/**
 * 虚拟钱包（加密货币钱包）前端工具
 * - WALLET_NETWORKS：常用的币种 + 网络，用于选择器与徽标配色
 * - parseWalletType()：把后端存的类型串解析成「徽标文字 + 网络 + 主题色」
 * - shortAddress()：地址缩略显示（保留首尾，便于肉眼核对）
 * 说明：不限制用户填写的类型；未知类型按 "TOKEN-NETWORK" 规则拆分，取不到就整体作为徽标。
 */

export const WALLET_NETWORKS = [
  { value: 'USDT-TRC20', token: 'USDT', network: 'TRC20', color: '#26a17b', expectLen: 34 },
  { value: 'USDT-ERC20', token: 'USDT', network: 'ERC20', color: '#627eea', expectLen: 42 },
  { value: 'USDT-BEP20', token: 'USDT', network: 'BEP20', color: '#f0b90b', expectLen: 42 },
  { value: 'BTC', token: 'BTC', network: '', color: '#f7931a', expectLen: 0 },
  { value: 'ETH', token: 'ETH', network: 'ERC20', color: '#627eea', expectLen: 42 }
]

const DEFAULT_COLOR = '#8c8c8c'

/**
 * 解析钱包类型
 * @param {string} type 后端 bankinfo / bankfenhang 里存的类型串，如 USDT-TRC20
 * @returns {{value:string, token:string, network:string, color:string, expectLen:number}}
 */
export function parseWalletType(type) {
  const raw = String(type === null || type === undefined ? '' : type).trim()
  if (!raw || raw.toLowerCase() === 'wallet') {
    return { value: '', token: 'WALLET', network: '', color: DEFAULT_COLOR, expectLen: 0 }
  }
  const hit = WALLET_NETWORKS.find(function (n) {
    return n.value.toLowerCase() === raw.toLowerCase()
  })
  if (hit) {
    return { value: hit.value, token: hit.token, network: hit.network, color: hit.color, expectLen: hit.expectLen }
  }
  const parts = raw.split(/[-_/\s]+/).filter(Boolean)
  if (parts.length >= 2) {
    return {
      value: raw,
      token: parts[0].toUpperCase(),
      network: parts.slice(1).join(' ').toUpperCase(),
      color: DEFAULT_COLOR,
      expectLen: 0
    }
  }
  return { value: raw, token: raw.toUpperCase(), network: '', color: DEFAULT_COLOR, expectLen: 0 }
}

/**
 * 地址缩略显示：保留头部 head 位与尾部 tail 位
 */
export function shortAddress(address, head, tail) {
  const h = head || 8
  const t = tail || 6
  const s = String(address === null || address === undefined ? '' : address).trim()
  if (s.length <= h + t + 3) return s
  return s.slice(0, h) + '...' + s.slice(-t)
}

/**
 * 复制文本：优先 navigator.clipboard，失败回落到 execCommand
 * @returns {Promise<boolean>}
 */
export function copyText(text) {
  const value = String(text === null || text === undefined ? '' : text)
  if (!value) return Promise.resolve(false)
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(value).then(function () {
      return true
    }).catch(function () {
      return Promise.resolve(fallbackCopy(value))
    })
  }
  return Promise.resolve(fallbackCopy(value))
}

function fallbackCopy(value) {
  const ta = document.createElement('textarea')
  ta.value = value
  ta.style.position = 'fixed'
  ta.style.top = '-1000px'
  document.body.appendChild(ta)
  ta.select()
  let ok = false
  try {
    ok = document.execCommand('copy')
  } catch (e) {
    ok = false
  }
  document.body.removeChild(ta)
  return ok
}
